import { render, staticRenderFns } from "./vFormWEBSITE.vue?vue&type=template&id=03d8b280&scoped=true&"
import script from "./vFormWEBSITE.vue?vue&type=script&lang=js&"
export * from "./vFormWEBSITE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8b280",
  null
  
)

export default component.exports